import { useAlertsStore } from '@shared/hooks/state/AlertsContainer';
import { useAuthStore } from '@shared/hooks/state/AuthContainer';
import { useCurrentUserStore } from '@shared/hooks/state/CurrentUserContainer';
import { useOrganizationStore } from '@shared/hooks/state/OrganizationContainer';
import { useEffect, useState } from 'react';

export function useAdminInitializeData() {
    const [isLoading, setIsLoading] = useState(true);
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
    const currentUser = useCurrentUserStore((state) => state.currentUser);
    const organizationLoading = useOrganizationStore((state) => state.loading);

    useEffect(() => {
        const initialize = async () => {
            try {
                const userResult = await useCurrentUserStore.getState().loadCurrentUser();
                if (userResult?.resultType === 'Ok') {
                    await useCurrentUserStore.getState().checkAndUpdatePendingTos();
                }
                await useCurrentUserStore.getState().loadUserLicenseAccess();
                await useOrganizationStore.getState().initializeFromRemote();
            } catch (error) {
                useAlertsStore.getState().showError('Error initializing data');
            } finally {
                setIsLoading(false);
            }
        };

        if (currentUser === null && isAuthenticated === true) {
            initialize();
        }
    }, [currentUser, isAuthenticated]);

    useEffect(() => {
        if (isAuthenticated && currentUser && !organizationLoading) {
            setIsLoading(false);
        }
    }, [isAuthenticated, currentUser, organizationLoading]);

    return { isLoading };
}
